import {Schema} from '@simpli/meta-schema'
import {$} from '@/facade'

export abstract class DefaultSchema extends Schema {
  abstract readonly name: string

  translateFrom(fieldName: string): string {
    return $.translate(`schema.${this.name}.${fieldName}`)
  }
}
